import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { UserContext } from "../UserContext";
import { CalendarComponent } from "./CalendarComponent";

export const CalendarContent = () => {
	const { handleTitle } = useContext(UserContext);
	const { t } = useTranslation();

	useEffect(() => {
		handleTitle(t("buttons.key_management"));
	}, []);

	return <CalendarComponent />;
};
